<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="系统编号">
              <a-input v-model="queryParam.number" placeholder="请输入" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24" v-if="false">
            <a-form-item label="类型">
              <div class="custom-select-container">
                <a-select
                  allow-clear
                  placeholder="类型"
                  v-model="queryParam.type"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_sell_contract_type">{{ val }}</a-select-option>
                </a-select>
              </div>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="采销全流程">
              <a-select
                show-search
                allow-clear
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                v-model="queryParam.project_id"
                placeholder="请输入名称"
                @search="this.projectSearch"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="产品名称">
              <a-input v-model="queryParam.product_name" placeholder="请输入" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="创建人">
              <a-input v-model="queryParam.create_by" placeholder="请输入" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
          </a-col>
          <a-col :md="2" :sm="24">
            <a-button type="primary" @click="handleAddSales">新建销售合同</a-button>
          </a-col>
          <a-col :md="2" :sm="24" v-if="false">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleArchived">批量存档</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1500 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="approval_needed" slot-scope="text, item">
        <a-popconfirm
          title="确定开启审批吗?"
          :disabled="text"
          @confirm="() => approvalNeeded(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
        </a-popconfirm>
      </span>
      <span slot="archived" slot-scope="text, item">
        <a-popconfirm
          title="确定存档吗?"
          :disabled="text"
          @confirm="() => archived(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
        </a-popconfirm>
      </span>
      <span slot="unit_price_type" slot-scope="text, item">
        <a-popover :title="(text === 4 && item.price_type !== null) ? '关联点价': dictionaries.unit_price_type[text] || '无'" v-if="text > 0 || item.price_type !== null">
          <template slot="content" v-if="item.price_type">
            <div v-if="text === 1">
              <a-row :gutter="[16,16]">
                <a-col :span="8">
                  <p>单价: {{ item.price_type.unit_price }} </p>
                </a-col>
                <a-col :span="8">
                  <p>临时单价是否含税: {{ item.price_type.is_tax_unit_price ? '是' : '否' }}</p>
                </a-col>
                <a-col :span="8">
                  <p>计价币种: {{ dictionaries.currency[item.price_type.pricing_currency] }}</p>
                </a-col>
                <a-col :span="8">
                  <p>收款币种: {{ dictionaries.currency[item.price_type.receive_pricing_currency] }}</p>
                </a-col>
                <a-col :span="8">
                  <p>汇率: {{ item.price_type.exchange_rate }}</p>
                </a-col>
                <a-col :span="8">
                  <p>数量: {{ item.price_type.pricing_count }}</p>
                </a-col>
                <a-col :span="8">
                  <p>合同金额: {{ item.price_type.contract_amount }}</p>
                </a-col>
                <a-col :span="8">
                  <p>合同金额是否含税: {{ item.price_type.is_tax_contract_amount ? '是' : '否' }}</p>
                </a-col>
              </a-row>
            </div>
            <div v-else-if="text === 2 || (text === 4 && item.price_type !== null)" style="width: 800px">
              <a-row :gutter="[16,16]">
                <a-col :span="8">
                  计价币种：<span class="important-content">{{ dictionaries.currency[item.price_type.pricing_currency] }}</span>
                </a-col>
                <a-col :span="8">
                  收款币种：<span class="important-content">{{ dictionaries.currency[item.price_type.receive_pricing_currency] }}</span>
                </a-col>
                <a-col :span="8">
                  升贴水：<span class="important-content">{{ item.price_type.premium_discount }} {{ dictionaries.currency[item.price_type.pricing_currency] }}</span>
                </a-col>
                <a-col :span="8">
                  点价费：<span class="important-content">{{ item.price_type.price_fixing_fee }} {{ dictionaries.currency[item.price_type.pricing_currency] }}</span>
                </a-col>
                <a-col :span="8" v-if="item.price_type.futures_contract_list.length > 1">
                  转月费：<span class="important-content">{{ item.price_type.monthly_transfer_fee }} {{ dictionaries.currency[item.price_type.pricing_currency] }}</span>
                </a-col>
                <a-col :span="8">
                  汇率类型：<span class="important-content">{{ dictionaries.exchange_rate[item.price_type.exchange_rate_type] }}</span>
                </a-col>
                <a-col :span="8" v-if="item.price_type.exchange_rate_type === 1">
                  固定汇率：<span class="important-content">{{ item.price_type.fixed_exchange_rate }}</span>
                </a-col>
                <a-col :span="8" v-if="item.price_type.exchange_rate_type === 2">
                  确定日期汇率：<span class="important-content">{{ item.price_type.fixed_date_rate }}</span>
                </a-col>
                <a-col :span="8" v-if="item.price_type.exchange_rate_type === 2">
                  汇率定义方式：<span class="important-content">{{ item.price_type.exchange_rate_definition }}</span>
                </a-col>
                <a-col :span="8" v-if="item.price_type.exchange_rate_type === 3">
                  不确定日期汇率：<span class="important-content">{{ item.price_type.unfixed_date_rate }}</span>
                </a-col>
                <a-col :span="8">
                  临时单价：<span class="important-content">{{ item.price_type.unit_price }}</span>
                </a-col>
                <a-col :span="8">
                  临时单价是否含税：<span class="important-content">{{ item.price_type.is_tax_unit_price ? '是' : '否' }}</span>
                </a-col>
                <a-col :span="8">
                  临时汇率：<span class="important-content">{{ item.price_type.temp_exchange_rate }}</span>
                </a-col>
                <a-col :span="8">
                  数量：<span class="important-content">{{ item.price_type.pricing_count }}</span>
                </a-col>
                <a-col :span="8">
                  合同金额：<span class="important-content">{{ item.price_type.contract_amount }}</span>
                </a-col>
                <a-col :span="8">
                  合同金额是否含税：<span class="important-content">{{ item.price_type.is_tax_contract_amount ? '是' : '否' }}</span>
                </a-col>
                <a-col :span="24"></a-col>
              </a-row>
              <div v-for="(futures_contract, index) in item.price_type.futures_contract_list" :key="index">
                <a-row :gutter="[16,16]">
                  <a-col :span="7">
                    <span>{{ futuresContractPreTitle(index) }}</span>期货合约：<span class="important-content">{{ futures_contract.futures_contract && futures_contract.futures_contract.substring(0, futures_contract.futures_contract.lastIndexOf('-')) }}</span>
                  </a-col>
                  <a-col :span="7">
                    <span>{{ futuresContractPreTitle(index) }}</span>锁价期限：<span class="important-content">{{ futures_contract.lock_up_date }}</span>
                  </a-col>
                  <a-col :span="10">
                    <span>{{ futuresContractPreTitle(index) }}</span>默认计价期：<span class="important-content">{{ futures_contract.pricing_period_start_date }}~{{ futures_contract.pricing_period_end_date }}</span>
                  </a-col>
                </a-row>
              </div>
            </div>
            <div v-else-if="text === 3" >
              <a-row :gutter="[16,16]">
                <a-col :span="8">
                  PACE指数对应日期：<span class="important-content">{{ item.price_type.pace_date && item.price_type.pace_date.substring(0, item.price_type.pace_date.lastIndexOf('-')) }}</span>
                </a-col>
                <a-col :span="8">
                  升贴水：<span class="important-content">{{ item.price_type.premium_discount }}</span>
                </a-col>
                <a-col :span="8">
                  计价币种: <span class="important-content">{{ dictionaries.currency[item.price_type.pricing_currency] }}</span>
                </a-col>
                <a-col :span="8">
                  汇率: <span class="important-content">{{ item.price_type.exchange_rate }}</span>
                </a-col>
                <a-col :span="8">
                  数量: <span class="important-content">{{ item.price_type.pricing_count }}</span>
                </a-col>
                <a-col :span="8">
                  合同金额: <span class="important-content">{{ item.price_type.contract_amount }}</span>
                </a-col>
                <a-col :span="8">
                  合同金额是否含税：<span class="important-content">{{ item.price_type.is_tax_contract_amount ? '是' : '否' }}</span>
                </a-col>
              </a-row>
            </div>
          </template>
          <a>{{ (text === 4 && item.price_type !== null) ? '关联点价': dictionaries.unit_price_type[text] || '无' }}</a>
        </a-popover>
        <span v-else>无</span>
      </span>
      <span slot="exchange_rate" slot-scope="text, item">
        <a-popover :title="dictionaries.exchange_rate[item.exchange_rate]">
          <template slot="content">
            <div v-if="item.exchange_rate === 1">
              {{ item.fixed_exchange_rate }}
            </div>
            <div v-else-if="item.exchange_rate === 2">
              <a-row :gutter="[16,16]" style="min-width: 400px">
                <a-col :span="10">
                  日期：{{ item.fixed_date_rate === '1970-01-01' ? '无' : item.fixed_date_rate }}
                </a-col>
                <a-col :span="14" v-if="item.exchange_rate_definition">
                  汇率定义方式：{{ item.exchange_rate_definition }}
                </a-col>
              </a-row>
            </div>
            <div v-else-if="item.exchange_rate === 3">
              {{ item.unfixed_date_rate }}
            </div>
          </template>
          <a>{{ dictionaries.exchange_rate[item.exchange_rate] }}</a>
        </a-popover>
      </span>
      <span slot="payment_method" slot-scope="text, item">
        <a-popover :title="paymentMethodTitle(item.payment_method)">
          <template slot="content">
            <div style="width: 400px;">
              <a-row :gutter="[16,16]">
                <a-col :span="12">
                  预付款金额：{{ item.pre_payment }} {{ item.pricing_currency === 1? '美元':'元' }}
                </a-col>
                <a-col :span="12" v-if="item.pre_payment_date && item.pre_payment_date !=='1970-01-01'">
                  预付款日期：{{ item.pre_payment_date }}
                </a-col>
              </a-row>
            </div>
          </template>
          <a>{{ paymentMethodTitle(item.payment_method) }}</a>
        </a-popover>
      </span>
      <span slot="balance_payment_method" slot-scope="text, item">
        <a-popover :title="balancePaymentMethodTitle(item.balance_payment_method)" v-if="item.balance_payment_method > 0 && item.balance_payment_method < 6">
          <template slot="content">
            <div style="width: 400px;">
              <a-row :gutter="[16,16]">
                <a-col :span="10">
                  尾款金额：<span class="important-content">{{ item.balance_payment }} {{ item.pricing_currency === 1? '美元':'元' }}</span>
                </a-col>
                <a-col :span="14">
                  <span v-if="item.trade_balance_payment_date_method === 1">
                    <span v-if="item.balance_payment_date && item.balance_payment_date !== '1970-01-01'">
                      确定尾款日期：<span class="important-content">{{ item.balance_payment_date }}</span>
                    </span>
                  </span>
                  <span v-else-if="item.trade_balance_payment_date_method === 2">
                    承兑日后：<span class="important-content">{{ item.trade_balance_payment_days }} 天</span>
                  </span>
                  <span v-else>
                    不确定尾款日期：<span class="important-content">{{ item.unbalance_payment_date_desc }}</span>
                  </span>
                </a-col>
              </a-row>
            </div>
          </template>
          <a>{{ balancePaymentMethodTitle(item.balance_payment_method) }}</a>
        </a-popover>
        <span v-else>
          {{ balancePaymentMethodTitle(item.balance_payment_method) }}
        </span>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a v-if="false"@click="handleKeyPoint(record)">关键点</a>
          <a-divider v-if="false" type="vertical" />
          <a-popconfirm
            v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"
            title="确定重启审批?"
            @confirm="() => approvalNeeded(record, 'trade_sell_contract', true)">
            <a>重启审批</a>
          </a-popconfirm>
          <a-divider v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)" type="vertical" />
          <a @click="handleClient(record)">附件</a>
          <a-divider type="vertical" />
          <a @click="handleWatchView(record)">预览</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a @click="handleEdit(record)" v-if="isEdited(record.create_by_id)">编辑</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="isEdited(record.create_by_id)"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider v-if="record.unit_price_type === 2 || record.version > 1 || record.unit_price_type === 4 || (record.is_approval_needed && record.status === 2 && isEdited(record.create_by_id))" type="vertical"/>
          <a-dropdown v-if="record.unit_price_type === 2 || record.version > 1 || record.unit_price_type === 4 || (record.is_approval_needed && record.status === 2 && isEdited(record.create_by_id))">
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-if="record.unit_price_type === 2">
                <a @click="handlePointPricing(record)">点价</a>
              </a-menu-item>
              <a-menu-item v-if="record.version > 1" >
                <a @click="handleModifyRecord(record)">查看修改</a>
              </a-menu-item>
              <a-menu-item v-if="false">
                <a @click="handleCopy(record)">复制合同</a>
              </a-menu-item>
              <a-menu-item v-if="record.is_approval_needed && record.status === 2 && isEdited(record.create_by_id)">
                <a @click="handlePushJd(record)">推送金蝶</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <archived-form
      ref="archivedModal"
      v-if="archivedVisible"
      :visible="archivedVisible"
      @cancel="handleArchivedCancel"
      @ok="handleArchivedOK"
    />
    <sell-contract-record :sellContract="mdl" :visible="recordVisible" @close="recordVisible=false" v-if="recordVisible"/>
    <point-price-apply :contract="mdl" :visible="pointPriceVisible" @cancel="pointPriceVisible=false" @ok="handlePointPricingOK" v-if="pointPriceVisible"/>
    <watch-view-form :model="mdl" :visible="watchViewVisible" @cancel="watchViewVisible=false" v-if="watchViewVisible"/>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import {
  sell_contract_list,
  sell_contract_create,
  sell_contract_delete,
  sell_contract_archived, sell_contract_valence_vertex_price_create, sell_contract_update, sell_contract_to_jd
} from '@/api/trade_sell_contract'
import CreateForm from '../../sell_contract/modules/CreateForm2'
import ArchivedForm from '../modules/ArchivedForm'
import BindPointPriceForm from '../modules/BindPointPriceForm'
import SellContractRecord from '../../project/modules/SellContractRecord'
import PointPriceApply from '../../project/modules/PointPriceApply'
import WatchViewForm from '../modules/WatchViewForm'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'
import { Modal } from 'ant-design-vue'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    ArchivedForm,
    SellContractRecord,
    PointPriceApply,
    BindPointPriceForm,
    WatchViewForm
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      dictionaries: this.$Dictionaries,
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archivedVisible: false,
      recordVisible: false,
      pointPriceVisible: false,
      contractBindVisible: false,
      watchViewVisible: false,
      projectFetching: false,
      projectList: [],
      mdl: {},
      // 查询参数
      queryParam: {
        client_ids: [],
        is_expired: false,
        filter: true,
        type: 2
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '系统编号',
          dataIndex: 'number',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '采销全流程',
          dataIndex: 'project',
          width: 150,
          ellipsis: true
        },
        {
          title: '合同号',
          dataIndex: 'contract_number',
          width: 180,
          ellipsis: true
        },
        {
          title: '合同名称',
          dataIndex: 'name',
          width: 120,
          ellipsis: true
        },
        {
          title: '客户',
          dataIndex: 'client',
          width: 120,
          ellipsis: true
        },
        {
          title: '贸易类型',
          dataIndex: 'trade_type',
          width: 120,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.trade_types[text] || '无'
        },
        {
          title: '产品名称',
          dataIndex: 'product_name',
          width: 120,
          ellipsis: true
        },
        {
          title: '数量',
          dataIndex: 'count',
          width: 120,
          ellipsis: true,
          customRender: (text, record) => text + (this.$Dictionaries.unit[record.unit] || '')
        },
        {
          title: '规格型号',
          dataIndex: 'spec',
          width: 120,
          ellipsis: true
        },
        {
          title: '贸易术语',
          dataIndex: 'trade_term',
          width: 120,
          ellipsis: true
        },
        {
          title: '交货地',
          dataIndex: 'delivery_address',
          width: 120,
          ellipsis: true
        },
        {
          title: '最迟交货日期',
          dataIndex: 'latest_delivery_date',
          width: 120,
          ellipsis: true,
          customRender: (text) => text === '1970-01-01' ? '无' : text
        },
        {
          title: '溢装率（%）',
          dataIndex: 'overloading_rate',
          width: 120,
          ellipsis: true
        },
        {
          title: '短装率（%）',
          dataIndex: 'shortage_rate',
          width: 120,
          ellipsis: true
        },
        {
          title: '增值税率',
          dataIndex: 'tax_rate',
          width: 120,
          ellipsis: true,
          customRender: (text) => text + '%'
        },
        {
          title: '定价方式',
          dataIndex: 'unit_price_type',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'unit_price_type' }
        },
        {
          title: '预付款方式',
          dataIndex: 'payment_method',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'payment_method' }
        },
        {
          title: '合同日期',
          dataIndex: 'contract_date',
          width: 120,
          ellipsis: true,
          customRender: (text) => text === '1970-01-01' ? '无' : text
        },
        {
          title: '版本',
          dataIndex: 'version',
          width: 120,
          align: 'center',
          ellipsis: true
        },
        {
          title: '已存档',
          dataIndex: 'is_archived',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'archived' }
        },
        {
          title: '开启审批',
          dataIndex: 'is_approval_needed',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'approval_needed' }
        },
        {
          title: '审批状态',
          dataIndex: 'status',
          align: 'center',
          width: 100,
          customRender: (text, record) => record.is_approval_needed ? this.$Dictionaries.approval_result[text] : '未开启审批'
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          ellipsis: true
        },
        {
          title: '时间',
          dataIndex: 'create_time',
          width: 180,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '240px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return sell_contract_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  computed: {
    paymentMethodTitle () {
      return (payment_method) => {
        return '' + (this.dictionaries.trade_pre_payment_method[payment_method] || '')
      }
    },
    balancePaymentMethodTitle () {
      return (payment_method) => {
        return '' + (this.dictionaries.trade_balance_payment_method[payment_method] || '')
      }
    },
    futuresContractPreTitle () {
      return (index) => {
        if (index === 0) {
          return ''
        } else if (index === 1) {
          return '转月后'
        } else if (index === 2) {
          return '二次转月后'
        } else {
          return (index + 1) + '次转月后'
        }
      }
    },
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAddPurchase () {
      const date = new Date()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      this.mdl = { number: date.getFullYear() + '' + (date.getMonth() + 1) + date.getDate() + hours + minutes }
      this.mdl['type'] = '1'
      this.visible = true
    },
    handleAddSales () {
      const date = new Date()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      this.mdl = { number: date.getFullYear() + '' + (date.getMonth() + 1) + date.getDate() + hours + minutes }
      this.mdl['type'] = '2'
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archivedVisible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    approvalNeeded (record, type, approval_again) {
      const is_approval_needed = approval_again ? true : !record.is_approval_needed
      if (is_approval_needed) {
        this.loading = true
        sell_contract_update({ is_approval_needed: true }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archivedVisible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleCopy (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/sell_contract/' + record.id + '/copy' })
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/sell_contract/' + record.id })
    },
    handleClient (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/sell_contract/' + record.id + '/attachment', query: { record: record.name } })
    },
    handleKeyPoint (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/sell_contract/' + record.id + '/keypoint', query: { record: record.name } })
    },
    handlePushJd (record) {
      const that = this
      Modal.confirm({
        title: '提醒',
        content: h => <div>确定推送到金蝶系统吗?</div>,
        onOk () {
          console.log('数据推送到金蝶11')
          that.loading = true
          if (that.loading) {
            return
          }
          sell_contract_to_jd(record.id).then((res) => {
            if (res.code === 1000) {
              that.$refs.table.refresh()
            }
          }).finally(() => {
            that.loading = false
          })
        },
        onCancel () {
          console.log('点击了按钮')
        }
      })
    },
    handleWatchView (record) {
      this.mdl = record
      this.watchViewVisible = true
    },
    handlePointPricing (record) {
      // 点价
      this.mdl = record
      this.pointPriceVisible = true
    },
    handleRelatedPurchase (record) {
      // 点价关联采购合同
      this.mdl = record
      this.contractBindVisible = true
    },
    handleModifyRecord (record) {
      // 查看修改记录
      this.mdl = record
      this.recordVisible = true
    },
    archived (record) {
      sell_contract_archived({ id: record.id, is_archived: !record.is_archived }).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleDelete (record) {
      sell_contract_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    normalizeFuturesContract (futures_contract) {
      const fc = String(futures_contract)
      if (/^\d{4}-\d{2}$/.test(fc)) {
        return fc + '-01'
      } else if (/^\d{4}-\d{2}-\d{2}$/.test(fc)) {
        return fc
      } else {
        return futures_contract
      }
    },
    unitPriceValues (values, data) {
      // 单价
      if (values) {
        if (values['unit_price_type'] === '2') {
          const turning_month_list = []
          const start_date = values['pricing_period'][0].format('YYYY-MM-DD')
          const end_date = values['pricing_period'][1].format('YYYY-MM-DD')
          const futures_contract = this.normalizeFuturesContract(values['futures_contract'])
          const lock_up_date = values['lock_up_date']
          turning_month_list.push({
            futures_contract: futures_contract,
            lock_up_date: lock_up_date,
            pricing_period_start_date: start_date,
            pricing_period_end_date: end_date
          })
          values['futures_contract'] = undefined
          values['lock_up_date'] = undefined
          values['pricing_period'] = undefined
          if (data.turning_month_list.length > 0) {
            const data_list = data.turning_month_list.map(item => {
              item['futures_contract'] = this.normalizeFuturesContract(item['futures_contract'])
              // const start_date = item['pricing_period']['start_date']
              // const end_date = item['pricing_period']['end_date']
              // item['pricing_period_start_date'] = start_date
              // item['pricing_period_end_date'] = end_date
              // item['pricing_period'] = undefined
              item['key'] = undefined
              return item
            })
            turning_month_list.push(...data_list)
          }
          data.turning_month_list = turning_month_list
          // values['turning_month_list'] = turning_month_list
        } else if (values['unit_price_type'] === '3') {
          if (values['price_reference_period']) {
            const start_date = values['price_reference_period'][0].format('YYYY-MM-DD')
            const end_date = values['price_reference_period'][1].format('YYYY-MM-DD')
            values['price_reference_period'] = undefined
            values['price_reference_period_start_date'] = start_date
            values['price_reference_period_end_date'] = end_date
          }
        }
      }
      return {
        values_new: values,
        data_new: data
      }
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
            // 新增
          values['type'] = '2'
          values.start_date = data.start_date
          values.end_date = data.end_date
          const { values_new, data_new } = this.unitPriceValues(values, data)
          if (data_new.product_parameters !== undefined) {
            data_new.product_parameters = data_new.product_parameters.map(item => {
              delete item['key']
              return item
            })
          }
          const custom_values = { ...values_new, ...data_new }
          console.log('values----2', custom_values)
          this.confirmLoading = true
          sell_contract_create(custom_values).then(res => {
              // 刷新表格
              if (res.code === 1000) {
                this.visible = false
                // 重置表单数据
                form.resetFields()
                this.$refs.table.refresh()
              }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          sell_contract_archived(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archivedVisible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    handlePointPricingOK (dataList) {
      const postDataList = dataList.map(item => {
        const mapItem = { ...item }
        if (mapItem.lock_price_type === 3) {
          if (mapItem.is_consecutive_dates) {
            mapItem['lock_price_start_date'] = mapItem.lock_date.split('~')[0]
            mapItem['lock_price_end_date'] = mapItem.lock_date.split('~')[1]
          } else {
            mapItem['lock_price_start_date'] = undefined
            mapItem['lock_price_end_date'] = undefined
          }
          mapItem['nature_price_list'] = mapItem['nature_price_list'].map(item => {
            delete item['editable']
            delete item['key']
            return item
          })
        } else {
          mapItem['lock_price_start_date'] = mapItem.lock_date
          mapItem['lock_price_end_date'] = undefined
        }
        delete mapItem['lock_date']
        delete mapItem['editable']
        delete mapItem['key']
        return mapItem
      })
      const data = {
        valence_vertex_list: postDataList,
        point_pricing_id: this.mdl.price_type.id
      }
      console.log('-------', data)
      sell_contract_valence_vertex_price_create(data).then(res => {
        if (res.code === 1000) {
          console.log('===============')
        }
      })
    },
    handleProjectSearch (value) {
      this.projectFetching = true
      this.projectList = []
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = result
      }).finally(() => {
        this.projectFetching = false
      })
    }
  }
}
</script>
